(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const observers = new Set();
  const enhance = (root = document) => {
    if (reduced.matches || !('IntersectionObserver' in window)) return;
    const targets = Array.from(root.querySelectorAll('[data-app-reveal], main .product-card-wrapper, main .banner__box, main .collection-list__item'));
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(({ target, isIntersecting }) => {
        if (!isIntersecting) return;
        target.classList.add('app-is-visible');
        observer.unobserve(target);
      });
    }, { threshold: 0.06, rootMargin: '0px 0px 30px 0px' });
    observers.add(observer);
    targets.forEach((target) => {
      if (target.hasAttribute('data-app-motion')) return;
      const box = target.getBoundingClientRect();
      target.setAttribute('data-app-motion', '');
      if (box.top < innerHeight && box.bottom > 0) target.classList.add('app-is-visible');
      else observer.observe(target);
    });
  };
  const stop = () => {
    observers.forEach((observer) => observer.disconnect());
    observers.clear();
    document.querySelectorAll('[data-app-motion]').forEach((target) => target.classList.add('app-is-visible'));
  };
  document.addEventListener('shopify:section:load', (event) => enhance(event.target));
  document.addEventListener('shopify:section:select', (event) => {
    event.target.querySelectorAll('[data-app-motion]').forEach((target) => target.classList.add('app-is-visible'));
  });
  reduced.addEventListener('change', () => reduced.matches ? stop() : enhance());
  addEventListener('pagehide', stop);
  addEventListener('pageshow', () => enhance());
  enhance();
})();


// Direct checkout adds the selected variant through Shopify's locale-aware cart API.
(() => {
  const sync = () => document.querySelectorAll('[data-app-buy-now]').forEach((button) => {
    if (button.dataset.busy) return;
    const form = button.closest('form');
    const add = form?.querySelector('[name="add"]');
    const disabled = !add || add.disabled;
    if (button.disabled !== disabled) button.disabled = disabled;
  });
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-app-buy-now]');
    if (!button || button.disabled || button.dataset.busy) return;
    event.preventDefault();
    const form = button.closest('form');
    const add = form?.querySelector('[name="add"]');
    const variant = form?.querySelector('[name="id"]');
    if (!form || !variant?.value || variant.disabled || add?.disabled) return;
    if (!form.reportValidity()) return;
    const body = new FormData(form);
    const errorWrap = form.closest('product-form')?.querySelector('.product-form__error-message-wrapper');
    const errorText = errorWrap?.querySelector('.product-form__error-message');
    if (errorWrap) errorWrap.hidden = true;
    const label = button.querySelector('span');
    button.dataset.busy = 'true';
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    if (add) add.disabled = true;
    label.textContent = 'Ouverture du paiement…';
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'cart/add.js', {method:'POST', body, headers:{Accept:'application/json'}});
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || 'Ce produit ne peut pas être ajouté pour le moment.');
      window.location.assign(root + 'checkout');
    } catch (error) {
      if (errorText && errorWrap) {
        errorText.textContent = error.message || 'Le paiement ne peut pas être ouvert. Réessayez dans un instant.';
        errorWrap.hidden = false;
      }
      delete button.dataset.busy;
      button.removeAttribute('aria-busy');
      if (add) add.disabled = false;
      label.textContent = 'Acheter maintenant';
      sync();
    }
  });
  new MutationObserver(sync).observe(document.documentElement,{subtree:true,childList:true,attributes:true,attributeFilter:['disabled']});
  addEventListener('pageshow', () => {
    document.querySelectorAll('[data-app-buy-now][data-busy]').forEach(button => {
      delete button.dataset.busy;
      button.removeAttribute('aria-busy');
      button.querySelector('span').textContent='Acheter maintenant';
      const add=button.closest('form')?.querySelector('[name="add"]');
      if(add) add.disabled=false;
    });
    sync();
  });
  sync();
})();
